<script>
import { appCopy, languageState } from '@/i18n';

const projectLinks = [
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/MJDHNODO-1711590377666Pasted Graphic 1.png',
    tech: 'Vue，Tailwind',
    github: 'null',
    demo: 'https://website.aiwgg.cn/'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/PHFKHGNC-1711595226918WGG BLOG.png',
    tech: 'VitePress',
    github: 'https://github.com/SSDWGG/ssdwgg.github.io',
    demo: 'https://blog.aiwgg.cn/'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/EFANMBKF-1711591497556Pasted Graphic 6.png',
    tech: 'React, AntDesign_Pro',
    github: 'null',
    demo: 'https://todo.aiwgg.cn/'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/NAICMCGG-1711594579198Pasted Graphic 7.png',
    tech: 'Vue2Js, Springboot',
    github: 'https://github.com/SSDWGG/rabbitMall',
    demo: 'https://mall.aiwgg.cn'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/common/KDLHCKEC-1711590640895Pasted Graphic 2.png',
    tech: 'Html, Github',
    github: 'https://github.com/SSDWGG',
    demo: 'https://github.com/SSDWGG'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779329074440-9/testapi111.png',
    tech: 'Html,LLM-test,AI',
    github: 'https://github.com/SSDWGG/testApiStation',
    demo: 'https://testapi.aiwgg.cn/',
    name:'API中转站置信度测试'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779329074440-15/sbti-test.png',
    tech: 'sbti-test',
    github: 'https://github.com/SSDWGG/sbti-test',
    demo: 'https://sbti-test.aiwgg.cn/',
    name:'SBTI人格测试'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779329074440-14/sbti-wiki.png',
    tech: 'sbti-wiki',
    github: 'https://github.com/SSDWGG/sbti-wiki',
    demo: 'https://sbti-wiki.aiwgg.cn/',
    name:'SBTI人格测试Wiki结果'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779521677757-6/9999.png',
    tech: 'opencv',
    github: 'https://github.com/SSDWGG/opencv',
    demo: 'https://opencv.aiwgg.cn/',
    name:'opencv'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779521677757-3/8888.png',
    tech: 'cat',
    github: 'https://github.com/SSDWGG/snake',
    demo: 'https://snake.aiwgg.cn/',
    name:'家庭猫咪'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779521677757-4/7777.png',
    tech: 'Mac app',
    github: 'https://github.com/SSDWGG/onemenu',
    demo: 'https://onemenu.aiwgg.cn/',
    name:'mac状态栏工具'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779521677757-5/666.png',
    tech: 'ios app',
    github: 'https://github.com/SSDWGG/mombaby',
    demo: 'https://mombaby.aiwgg.cn/',
    name:'喂养母婴助手'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-3/666666.png',
    tech: 'ios app',
    github: 'https://github.com/SSDWGG/svs',
    demo: 'https://svs.aiwgg.cn/',
    name:'口语练习助手'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-4/555555.png',
    tech: 'ios app',
    github: 'https://github.com/SSDWGG/trajectory',
    demo: 'https://trajectory.aiwgg.cn/',
    name:'足迹记录'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-5/44444.png',
    tech: 'ios app',
    github: 'https://github.com/SSDWGG/rday',
    demo: 'https://rday.aiwgg.cn/',
    name:'倒数日'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-6/3333.png',
    tech: 'ios app',
    github: 'https://github.com/SSDWGG/iosgame',
    demo: 'https://iosgame.aiwgg.cn/',
    name:'口袋街机'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-7/2222.png',
    tech: 'ERP vue',
    github: 'https://github.com/SSDWGG/icon_erp',
    demo: 'https://icon-erp.aiwgg.cn/',
    name:'ERP管理系统'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779523113524-8/1111.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://smi.aiwgg.cn/',
    name:'SMI网站'
  },
  // 新增
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-3/8888.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://hx.aiwgg.cn/',
    name:'南京河西外国语国际部官网'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-8/7777.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://lm.aiwgg.cn/',
    name:'力邁學校网站'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-9/6666.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://bit.aiwgg.cn/',
    name:'北京理工大学A-Level网站'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-4/555.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://xm.aiwgg.cn/',
    name:'漳州康桥学校国际部网站'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-6/4444.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://ydelite.aiwgg.cn/',
    name:'深圳市云顶学校网站'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-5/333.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://zhstar.aiwgg.cn/',
    name:'珠海之星学校网站'
  },

  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-7/2222.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://nit.aiwgg.cn/',
    name:'宁波经理学院国际课程中心'
  },
  {
    imageUrl: 'https://panshi-on.oss-cn-hangzhou.aliyuncs.com/yunxiaoding-mini/other/wggw/vc-upload-1779789462309-10/111.png',
    tech: 'next web',
    github: 'null',
    demo: 'https://nhw.aiwgg.cn/',
    name:'佛山南海湾实验中学网站'
  },
];

export default {
  data() {
    return {
      activeTab: 1,
      languageState,
    };
  },
  computed: {
    portfolioCopy() {
      return appCopy[this.languageState.locale].portfolio;
    },
    items() {
      return projectLinks.map((project, index) => ({
        ...project,
        ...(this.portfolioCopy.items[index] || {}),
      }));
    },
  },

}
</script>
<template>
  <div class="px-5 py-5 md:px-12 md:py-10 text-left text-amber-50 mx-3">
    <article data-page="about">
      <header>
        <div
          class="text-2xl font-bold text-white mb-10 fadein-bot title-section flex items-center justify-center flex-col">

          <h4>{{ portfolioCopy.heading }}</h4>
          <!--          <div class="h-[1px] w-10 bg-amber-200 md:w-20 aos-init aos-animate"></div>-->
          <h4 class="text-base font-normal text-transparent bg-clip-text bg-gradient-to-r from-slate-100 to-amber-300">
            {{ portfolioCopy.subtitle }}</h4>

        </div>
      </header>
      <section>
        <div>
          <div
            class="grid grid-cols-1 gap-4 pb-10 md:grid-cols-3 md:gap-3 xl:grid-cols-3 xl:gap-3 2xl:gap-5 fade-zoom-in">
            <a v-for="item in items" :key="item.demo" :href="item.demo" target="_blank" rel="noreferrer">
              <div
                class="item-card flex flex-col items-center gap-2 rounded bg-[#1e1e1f] hover:bg-[#282828] border border-[#383838] rounded-xl text-amber-50 md:gap-3 px-5 py-5 lg:px-5 ">
                <div class="flex h-12 w-12 items-center justify-center p-0 h-full w-full lg:p-0 zoom-in">
                  <img alt="HTML" loading="lazy" decoding="async" data-nimg="1" class="drop-shadow-xl rounded rounded-xl"
                    :src="item.imageUrl">
                </div>
                <div class="w-full flex flex-col gap-2 items-center text-sm md:text-base lg:text-lg">
                  <div class="title-text font-medium text-secondary">{{ item.name }}
                  </div>
                  <div class="w-full text-left text-[10px] text-[#c1c1c1] md:text-xs lg:text-sm">
                    {{ item.status }}
                  </div>
                  <div class="w-full mt-4 text-normal text-sm text-left text-amber-200">
                    {{ item.tech }}
                  </div>
                  <div class="w-full flex justify-end">
                    <div class="flex cursor-pointer items-end gap-2 text-primary">
                      <a v-if="item.github !== 'null'" :href="item.github" target="_blank" rel="noreferrer" :title="portfolioCopy.sourceTitle"
                        class="transition-all hover:text-accent">
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round"
                          stroke-linejoin="round" height="16" width="16" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22">
                          </path>
                        </svg>
                      </a>
                      <a v-if="item.demo !== 'null'" :href="item.demo" target="_blank" rel="noreferrer" :title="portfolioCopy.demoTitle"
                        class="transition-all hover:text-accent">
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round"
                          stroke-linejoin="round" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          <polyline points="15 3 21 3 21 9"></polyline>
                          <line x1="10" y1="14" x2="21" y2="3"></line>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<style>
.item-card:hover {
  transition: transform 0.3s ease;
  transform: translateY(-8px);
}

svg:hover {
  stroke: #ffdb70;
}

@keyframes fadeZoomIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Menggunakan animasi pada elemen yang diinginkan */
.fade-zoom-in {
  animation: fadeZoomIn 1s ease-in-out;
}
</style>
